
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {ProjectDocument} from "@/interfaces/project.interfaces";
import {UserProjectDocument} from "@/interfaces/user.project.interfaces";
import {addUserToProject, fetchUsers, fetchUsersProject, removeUserProject} from "@/axios/axios.user";
import {UserProjectContributor} from "@/interfaces/user.interfaces";
import SAccContributorsBlock from "@/components/projects/SAccContributorsBlock.vue";

@Component({
  components: {SAccContributorsBlock}
})
export default class SAccProjectUsers extends Vue {
  // Les props
  @Prop() private project!: ProjectDocument | null
  @Prop() private height!: number

  // Les propriétés
  private loadedSourceUsers: UserProjectDocument[] = []
  private targetUsers: UserProjectDocument[] = []
  private loading: boolean = false



  // Les propriétés calculées
  private get sourceUsers(): UserProjectDocument[] {
    return this.loadedSourceUsers.filter(ups => {
      const idx = this.targetUsers.findIndex(upt => ups.user._id === upt.user._id)
      return idx < 0
    })
  }

  // Les hooks
  public async mounted() {
    // window.addEventListener('resize', this.ajustHeight)
    await this.loadTargetUser()
    await this.loadSourceUser()
  }

  // Les méthodes surveillées
  @Watch('project')
  private onChangeProject() {
    if (this.project) {
      this.loadTargetUser()
    }
  }

  // Les méthodes d'instance
  private async loadSourceUser() {
    this.loading = true
    const users = await fetchUsers()
    this.loadedSourceUsers = users
        .filter(u => !u.isDead)
        .map<UserProjectDocument>(u => {
          return {
            _id: '',
            user: (u as UserProjectContributor),
            project: ''
          }
        })
    this.loading = false
  }

  private async loadTargetUser() {
    if (this.project) {
      this.loading = true
      this.targetUsers = await fetchUsersProject(this.project._id)
      this.loading = false
    }
  }

  private async Associate(up: UserProjectDocument) {
    if (this.project) {
      this.loading = true
      this.targetUsers = await addUserToProject(up.user._id, this.project._id)
      this.loading = false
    }
  }

  private async Dissociate(up: UserProjectDocument) {
    this.loading = true
    this.targetUsers = await removeUserProject(up._id)
    this.loading = false
  }


  // Les méthodes statiques
}
